<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchRRPayoff(1)">
                    <multiselect
                        v-model="search.vendor"
                        class="form-control border-0"
                        :options="optionVendor"
                        :customLabel="vendorLabel"
                        placeholder="รหัสเจ้าหนี้"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.account"
                        placeholder="รหัสบัญชี"/>
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.no"
                        placeholder="เลข CS"/>
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.bill"
                        placeholder="เลขใบวางบิล"/>
                    <input
                        class="form-control mr-sm-2"
                        type="text"
                        v-model="search.total_amount"
                        placeholder="ยอดเงินจ่าย"/>
                    <date-picker
                        v-model="search.receive_date"
                        :lang="lang"
                        :format="changeFormat"
                        range
                        confirm
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                    </date-picker>
                    &nbsp&nbsp
                    <b-form-select
                        v-model="search.payment_type"
                        :options="payment_type">
                    </b-form-select>
                    &nbsp&nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchRRPayoff(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="showApproveModal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="plus"></icon>
                        ตัดจ่าย
                    </button>
                    &nbsp
                    <!--                    <button @click="viewreport"-->
                    <!--                            class="btn btn-success my-2 my-sm-0"-->
                    <!--                            type="button">-->
                    <!--                        <icon name="print"></icon>-->
                    <!--                         รายงานค่าใช้จ่าย-->
                    <!--                    </button>&nbsp-->
                    <button @click="viewreport2"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        รายงานค่าใช้จ่ายแยกเซลล์
                    </button>
                    &nbsp
                    <button @click="createTax"
                            class="btn btn-default next"
                            :disabled="this.checkbox_id.length < 1"
                            type="button">
                        <icon name="print"></icon>
                        สร้างใบกำกับภาษี
                    </button>
                    &nbsp
                    <button @click="MultiPrint"
                            class="btn btn-default next"
                            :disabled="this.checkbox_id.length < 1"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์หลายใบ
                    </button>
                    &nbsp
                    <button @click="showVendorModal"
                            class="btn btn-default next"
                            type="button">
                        <icon name="print"></icon>
                        รายงานค่าใช้จ่ายรายเจ้าหนี้
                    </button>
                    &nbsp
                    <button @click="printVendorExcel"
                            v-if="canViewSuperAdmin"
                            class="btn btn-default next"
                            type="button">
                        <icon name="print"></icon>
                        รายงานผู้จำหน่าย(Excel)
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <!--                        <input type="checkbox" v-model="selectAll"/>-->
                    </th>
                    <th scope="col">vat 7%</th>
                    <th scope="col">ใบกำกับภาษี</th>
                    <th scope="col">เลขภาษีจากผู้จำหน่าย</th>
                    <th scope="col">เลขที่เอกสาร</th>
                    <th scope="col">วันที่บันทึก</th>
                    <th scope="col">ยอดเงินจ่าย</th>
                    <th scope="col">รหัสเจ้าหนี้</th>
                    <th scope="col">เจ้าหนี้</th>
                    <th scope="col">ช่องทางการชำระเงิน</th>
                    <th scope="col">เลขใบวางบิล</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">พิมพ์</th>
                    <th scope="col">ดูข้อมูล</th>
                    <th scope="col">ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in RRPayoffList">
                    <td>
                        <input type="checkbox" v-model="checkbox_id" :value="data.id"/>
                    </td>
                    <td>
                        <template v-if="data.is_vat">
                            <icon name="check" color="green"></icon>
                        </template>
                        <template v-else>
                            <icon name="times" color="red"></icon>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.create_tax">
                            <icon name="check" color="green"></icon>
                        </template>
                        <template v-else>
                            <icon name="times" color="red"></icon>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.tax_from_vendor">{{ data.tax_from_vendor }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.no">{{ data.no }}</template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.receive_date | moment("DD/MM/YYYY") }}</td>
                    <!--                    <td>{{data.bill_no?data.bill_no:'-' }}</td>-->
                    <!--                    <td>{{data.bill_date?data.bill_date:'-' | moment("DD/MM/YYYY") }}</td>-->
                    <td>{{ data.total_amount | currency }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.vendor_id }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <template v-for="transaction in data.transaction_types">
                            - {{ transaction.transaction_type.name }}<br>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.payment_type">
                            {{ data.bill_no }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.status==2">
                            <span style="color: #00a699">ตรวจสอบแล้ว</span>
                        </template>
                        <template v-else>
                            <a @click="editPayoff(data.payment_type,data.id,1)"
                               style="text-decoration: underline; color: red">
                                รอการตรวจสอบ
                            </a>
                        </template>
                    </td>
                    <td>
                        <a :href="domain + data.id" target="_blank" class="btn btn-primary">
                            พิมพ์
                        </a>
                    </td>
                    <td>
                        <button class="btn btn-info" @click="showPayoff(data.payment_type,data.id,data.status)">
                            <icon name="pencil-alt"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-danger" @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                            ยกเลิก
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPage">
            </vue-pagination>
        </div>
        <!--modal approve-->
        <b-modal hide-header hide-footer ref="approve">
            <div class="text-center">
                <h2>ประเภทการตัดจ่าย</h2>
                <br/>
                <b-row sm="10">
                    <b-col sm="4" class="col text-right">
                        <label>ประเภทการจ่าย</label>
                    </b-col>
                    <b-col sm="6">
                        <b-form-select
                            v-model="payment_type_id"
                            :options="payment_type">
                        </b-form-select>
                    </b-col>
                </b-row>
            </div>
            <br/>
            <div class="col text-center">
                <button @click="goToPayoffCreate(payment_type_id)"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button @click="hideApproveModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!---delete--->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deletePayoff">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!---vendor--->
        <b-modal hide-header hide-footer ref="vendor">
            <div>
                <div class="row">
                    <div class="col-4">
                        <span>เดือนที่ต้องการ</span>
                    </div>
                    <div class="col-7">
                        <date-picker
                            v-model="vendor.date"
                            :lang="lang"
                            :format="changeFormat"
                            class="w-100"
                            range
                            confirm
                            placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                        </date-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <span>เจ้าหนี้</span>
                    </div>
                    <div class="col-7">
                        <multiselect
                            v-model="vendor.vendor"
                            class="form-control border-0"
                            :options="optionVendor"
                            multiple
                            :customLabel="vendorLabel"
                            placeholder="รหัสเจ้าหนี้"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                    </div>
                </div>
                <br/>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="submitVendor">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideVendorModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
            </loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {domain} from "../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";
import {canViewSuperAdmin} from "../../../util/Permissions";

export default {
    components: {
        Loading,
        VuePagination,
        DatePicker,
        Multiselect,
    },
    name: "payment",
    data() {
        return {
            status_loading: 1,
            msg: 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            payment_type: [
                {text: "ประเภทการจ่าย", value: ""},
                {text: "รายการชำระหนี้", value: 1},
                {text: "ค่าใช้จ่ายอื่นๆ", value: 2},
                {text: "ค่ามัดจำ", value: 3},
                {text: "ค่าชำระหนี้โครงการ", value: 4},
            ],
            domain: "",
            payment_type_id: 1,
            event_submit: false,
            checkbox_id: [],
            select_all: false,
            delete_id: "",
            page: 1,
            vendor: {
                vendor: [],
                date: []
            }
        }
    },
    created() {
        this.domain = domain + '/rr-payoff-pdf/';
        this.$store.dispatch("RRPayoff/getRRpayoff");
        this.$store.dispatch("RRPayoff/clearSearch");
        this.$store.dispatch("Vendor/getVendorAll")
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            RRPayoffList: state => {
                return state.RRPayoff.RRPayoffList
            },
            form: state => {
                return state.RRPayoff.form
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            },
            search: state => {
                return state.RRPayoff.search;
            },
            dataPaginate: state => {
                return state.RRPayoff.dataPaginate
            }
        }),
        selectAll: {
            get: function () {
                return this.RRPayoffList ? this.checkbox_id.length >= this.RRPayoffList.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.$store.dispatch("RRPayoff/getRRPayoffIdfAll").then(id => {
                        this.checkbox_id = id; //return id
                    })
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            }
        },
    },
    methods: {
        canViewSuperAdmin,
        MultiPrint() {
            let id = '';
            this.checkbox_id.forEach((x, i) => {
                i == this.checkbox_id.length - 1 ? id += x : id += x + ',';
            })
            window.open(this.domain + id + '?continue=true');
        },
        createTax() {
            this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            let id = '';
            this.checkbox_id.forEach((x, i) => {
                if (i > 0) id += ',' + x;
                else id += x;
            })
            this.hideLoadingModal();
            this.$store.dispatch("RRPayoff/createTax", id).then(() => {
                this.$router.push({name: 'tax-payment-list'})
            })
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showApproveModal() {
            this.$refs.approve.show();
        },
        viewreport() {
            window.open(`${domain}/tableau/reportPayment`);
        },
        viewreport2() {
            window.open(`${domain}/tableau/reportPayoff`);
        },
        hideApproveModal() {
            this.$refs.approve.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideVendorModal() {
            this.$refs.vendor.hide();
        },
        showVendorModal() {
            this.$refs.vendor.show();
        },
        submitVendor() {
            let vendor_id = '';
            let date_start = '';
            let date_end = '';
            if (this.vendor.vendor.length > 0) {
                this.vendor.vendor.forEach((a, i) => {
                    this.vendor.vendor.length == i + 1 ? vendor_id += +a.id : vendor_id += +a.id + ',';
                })
            }
            if (this.vendor.date.length > 0) {
                date_start = moment(this.vendor.date[0]).format('DD-MM-YYYY');
                date_end = moment(this.vendor.date[1]).format('DD-MM-YYYY');
            }
            window.open(domain + '/rr_by_vendor?vendor_id=' + vendor_id + '&date_start=' + date_start + '&date_end=' + date_end)
            //console.log(vendor_id,date_start,date_end)
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        goToPayoffCreate(payment_type) {
            let status = null;
            this.$store.dispatch("RRPayoff/clearData");
            this.goToPayoffForm(payment_type, status)
        },
        goToPayoffForm(payment_type, status) {
            //console.log(status);
            if (payment_type === 1) {
                this.$router.push({
                    name: "payment-form1",
                    params: {payment_type: payment_type, status: status}

                })
            } else if (payment_type === 2) {
                this.$router.push({
                    name: "payoff-other",
                    params: {payment_type: payment_type, status: status}
                })
            } else if (payment_type === 3) {
                this.$router.push({
                    name: "payoff-po",
                    params: {payment_type: payment_type, status: status}
                })
            } else if (payment_type === 4) {
                this.$router.push({
                    name: "payment-project",
                    params: {payment_type: payment_type, status: status}
                })
            } else {
                this.hideApproveModal();
            }
        },
        searchRRPayoff(page) {
            //change date format
            let start_date = "";
            let end_date = "";
            this.event_submit = true;
            if (this.search.receive_date.length > 0 && this.search.receive_date[0]) {
                start_date = moment(this.search.receive_date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.receive_date[1]).format("YYYY-MM-DD");
            } else {
                this.search.receive_date = [];
            }
            let data = {
                vendor_id: "",
                total_amount: this.search.total_amount,
                start_date: start_date,
                end_date: end_date,
                payment_type: this.search.payment_type,
                no: this.search.no,
                account: this.search.account,
                bill: this.search.bill,
            };
            if (this.search.vendor) {
                data.vendor_id = this.search.vendor.id;
            }
            this.$store.dispatch("RRPayoff/search", {
                page: page,
                data: data
            })
        },
        showPayoff(payment_type, id, status = null) {
            this.showLoadingModal();
            this.$store.dispatch("RRPayoff/getRRpayoffById", id).then(() => {
                this.goToPayoffForm(payment_type, status);
                this.hideLoadingModal();
            });
        },
        editPayoff(payment_type, id, status) {
            this.showLoadingModal();
            this.$store.dispatch("RRPayoff/getRRpayoffById", id).then(() => {
                this.goToPayoffForm(payment_type, status);
                this.hideLoadingModal();
            });
        },
        createTaxPayoff() {
            let data = {
                rr_payoff_id: this.checkbox_id
            };
            this.$store.dispatch("TaxPayoff/createTaxPayoff", data).then(() => {
                this.$router.push("/accounting/tax-payoff");
            });
        },
        deletePayoff() {
            this.$store.dispatch("RRPayoff/deleteRRpayoffById", this.delete_id).then(() => {
                this.$store.dispatch("RRPayoff/getRRpayoff");
                this.hideDeleteModal();
            });
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchRRPayoff(this.page);
            } else {
                this.$store.dispatch("RRPayoff/getRRpayoff", this.page);
            }
        },
        printVendorExcel(){
            window.open(domain + '/new-vendor-excel','_blank');
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
